import React, { useState } from 'react';

const QAItem = ({title, children}) => {
    const [isOpen, setIsOpen] = useState(false);
    return(
        <div className="c-qa__item">
            <h3 className="c-qa__title" onClick={() => setIsOpen(!isOpen)}>
                {title}
                <span className={`c-qa__arrow${isOpen ? ' is-open' : ''}`}><img src="../images/arrow01.png" alt="" /></span>
            </h3>
            <div className={`c-qa__body${isOpen ? ' is-open' : ''}`}>
                <div className="c-qa__content">{children}</div>
            </div>
        </div>
    )
}

export default QAItem;